import { View } from 'react-native';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { spacing } from '@tabbio/tokens';
import { Text } from '../common/AppText';
import { NativeButton } from '../common/NativeButton';
import { useTheme } from '../../hooks/useTheme';
import { cvReviewEnabled, fetchCvShareReleaseSelection, fetchCvReleases } from '../../lib/cv-release-api';

export function CvShareReleaseChoice({ target, variantId, value, onChange }: {
  target: string; variantId: string | null; value: { mode: 'follow_approved' | 'exact'; releaseId?: string };
  onChange(value: { mode: 'follow_approved' | 'exact'; releaseId?: string }): void;
}) {
  const { t } = useTranslation('seeker');
  const { theme } = useTheme();
  const preview = useQuery({ queryKey: ['cv', target, 'release-share-selection', variantId], queryFn: () => fetchCvShareReleaseSelection(target, variantId), enabled: cvReviewEnabled });
  const releases = useQuery({ queryKey: ['cv', target, 'releases', variantId], queryFn: () => fetchCvReleases(target, variantId), enabled: cvReviewEnabled && value.mode === 'exact' });
  if (!cvReviewEnabled) return null;
  return <View style={{ gap: spacing[2] }}>
    <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: spacing[2] }}>
      <NativeButton title={t('cv.review.followApproved')} variant={value.mode === 'follow_approved' ? 'solid' : 'outline'} size="sm"
        onPress={() => onChange({ mode: 'follow_approved' })} />
      <NativeButton title={t('cv.review.exactVersion')} variant={value.mode === 'exact' ? 'solid' : 'outline'} size="sm"
        onPress={() => onChange({ mode: 'exact', releaseId: preview.data?.approvedReleaseId ?? undefined })} />
    </View>
    {!preview.data?.approvedReleaseId && !preview.isPending ? <Text style={{ color: theme.textSecondary }}>{t('cv.review.needsApproval')}</Text> : null}
    {value.mode === 'exact' ? <>
      <Text style={{ color: theme.textSecondary }}>{t('cv.review.chooseApproved')}</Text>
      {(releases.data ?? []).filter((release) => release.operation === 'release.approve').map((release) => <NativeButton key={release.id}
        title={t('cv.review.approvedAt', { date: new Date(release.createdAt).toLocaleString() })} size="sm"
        variant={value.releaseId === release.id ? 'solid' : 'outline'} onPress={() => onChange({ mode: 'exact', releaseId: release.id })} />)}
    </> : null}
  </View>;
}
